export default __webpack_public_path__ + "static/media/developer-img.2275bc67.jpg";